import React from "react";
import { TrashIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";

const CartCard = ({ item, onRemove }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <div className="flex items-stretch border rounded-lg shadow-sm hover:shadow-md transition-all my-2 overflow-hidden">
      {/* Image */}
      <div className="w-1/5 h-32 overflow-hidden">
        <img
          src={item.image_url || item.imageUrl}
          alt={item.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      {/* Contenu */}
      <div className="flex-1 flex flex-col justify-between px-4 py-2">
        {/* Nom et description */}
        <div>
          <h3 className="font-bold text-md text-gray-800 leading-snug line-clamp-2">
            {lang == "fr" ? item.nameFr : item.nameEn}
          </h3>
          <p className="text-gray-500 text-sm leading-relaxed break-words line-clamp-3">
            {lang == "fr" ? item.descriptionFr : item.descriptionEn}
          </p>
        </div>

        {/* Prix */}
        <p className="text-sm font-bold mt-2">
          {t("cart.unitPrice")} : ${item.price.toFixed(2)}
        </p>
        <p className="text-sm font-bold">
          {t("cart.quantity")} : {item.quantity}
        </p>
      </div>

      {/* Bouton Supprimer */}
      <button
        onClick={onRemove}
        className="p-4 text-gray-600 hover:text-red-700 transition"
      >
        <TrashIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

export default CartCard;
